import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import ProtectedRouteSuperDistributor from 'routes/ProtectedSuperdistributorEmployee';
import DayBook from 'views/quicklypayEmployeeDashboard/DayBook';
import PendingApproval from 'views/quicklypayEmployeeDashboard/PendingApproval';
import MyselfApproval from 'views/quicklypayEmployeeDashboard/MyselfApproval';
import TransactionList from 'views/quicklypayEmployeeDashboard/TransactionList';

const LandingPage = Loadable(lazy(() => import('views/quicklypayEmployeeDashboard/Dashboard')));
export const QuicklyPayEmployeeRoutes = {
    path: '',
    children: [
        { path: 'home', element: <ProtectedRouteSuperDistributor element={<LandingPage />} /> },
        { path: 'day-book', element: <ProtectedRouteSuperDistributor element={<DayBook />} /> },
        { path: 'pending-approval', element: <ProtectedRouteSuperDistributor element={<PendingApproval />} /> },
        { path: 'myself-approval', element: <ProtectedRouteSuperDistributor element={<MyselfApproval />} /> },
        { path: 'transaction-list', element: <ProtectedRouteSuperDistributor element={<TransactionList />} /> }
    ]
};
